import TenantPage from 'components/common/TenantPage';
import { useTranslation } from 'react-i18next';
import { ICreateAccessorPayload } from 'interfaces';
import AccessorForm from '../AccessorForm';
import { useCreateAccessor } from '../hooks';

const initAccessor: ICreateAccessorPayload = {
  code: null,
  equipment: null,
  description: null,
  serial_number: null
};

export const CreateAccessor = () => {
  const translationPrefix = 'pages.accessories';
  const { t } = useTranslation();
  const { onSubmit } = useCreateAccessor();

  return (
    <TenantPage title={t(`${translationPrefix}.add`)} subtitle="">
      <AccessorForm accessor={initAccessor} onSubmit={onSubmit} />
    </TenantPage>
  );
};

export default CreateAccessor;
